import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";


export default function CurrencyEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const language = useUserLanguage();
const { translations } = useTranslations(language);
const getText = (key, def) => translations[key] || def;


  const [form, setForm] = useState({
    code: "",
    symbol: "",
    name: "",
    is_default: 0,
    status: 1,
  });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/currencies/${id}`)
      .then((res) => setForm(res.data))
      .catch(() => toast.error(getText("DATA_FETCH_ERROR")));
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/api/currencies/${id}`,
      form
    );

    toast.success(getText("CURRENCY_UPDATED_SUCCESS"));
    navigate("/currency/table");
  };

  return (
    <div className="container card p-4 mt-3">

      <form onSubmit={handleSubmit}>
        {/* Kod */}
        <div className="mb-2">
          <label className="form-label fw-bold">{getText("CURRENCY_CODE_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            name="code"
            value={form.code || ""}
            onChange={handleChange}
          />
        </div>

        {/* Sembol */}
        <div className="mb-2">
          <label className="form-label fw-bold">{getText("CURRENCY_SYMBOL_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            name="symbol"
            value={form.symbol || ""}
            onChange={handleChange}
          />
        </div>

        {/* İsim */}
        <div className="mb-2">
          <label className="form-label fw-bold">{getText("CURRENCY_NAME_LABEL")}</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={form.name || ""}
            onChange={handleChange}
          />
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-primary">
            {getText("SAVE")}
          </button>
        </div>
      </form>
    </div>
  );
}
